import BaseService from "../BaseService";
import { config } from "../../config";
import axios from "axios";

class ViettelEkycService extends BaseService {
    constructor() {
        super(config.viettel.ekycURL, {
            "Content-type": "multipart/form-data",
        });
    }

    postEkyc = async (url: string, data: any) => {
        const formData = new FormData();
        formData.append("token", this.configEnv.viettel.token);
        const formArray: [string, string | Blob][] = Object.entries(data);
        formArray.forEach(([key, value]) => {
            formData.append(key, value);
        });

        const result = await axios.post(config.viettel.ekycURL + url,formData,{headers:{"Content-type": "multipart/form-data"}})

        return result.data
    };

    ekycFaceLiveness = async (file: any) => {
        try {
            const result:any = await this.postEkyc("/face_liveness", {
                file,
                label_pose: "Portrait",
            });
            if (result.code == 1) {
                if (!result.verify_result) {
                    return {
                        status: "fail",
                        message: "Vui lòng chụp chính xác khuôn mặt của bạn",
                    };
                }
                if (result.score < 0.8) {
                    return {
                        status: "fail",
                        message: "Độ tin cậy của hình chụp quá thấp",
                    };
                }
                return {
                    status: "pass",
                    message: "Hình chụp gương mặt đã hợp lệ",
                };
            } else {
                return {
                    status: "fail",
                    message: result.message,
                };
            }
            return result;
        } catch (error:any) {
            return {
                status: "error",
                message: error.response.data.vi_message,
            };
        }
    };

    ekycFaceQualityCheck = async (file: any) => {
        try {
            const result:any = await this.postEkyc("/face_quality_check", { file });
            if (result.code == 1) {
                return {
                    status: "pass",
                    message: "Hình chụp gương mặt đã hợp lệ",
                };
            } else {
                return {
                    status: "fail",
                    message: result.message,
                };
            }
        } catch (error:any) {
            return {
                status: "error",
                message: error.response.data.vi_message,
            };
        }
    };

    ekycIdTypeCheck = async (file: any, type: string) => {
        try {
            const result:any = await this.postEkyc("/id_type_check", {
                file,
            });
            if (result.code == 1) {
                if (
                    result.result == 'CCCD_front' ||
                    result.result == 'CCCD_back' ||
                    result.result == 'CCCD_FRONT_CHIP' ||
                    result.result == 'CCCD_BACK_CHIP'
                ) {
                    if (type == 'idFront' && result.result != 'CCCD_front' && result.result != 'CCCD_FRONT_CHIP') {
                        return {
                            status: 'fail',
                            message: 'Vui lòng chụp mặt trước của CCCD'
                        }
                    }
                    if (type == 'idBack' && result.result != 'CCCD_back' && result.result != 'CCCD_BACK_CHIP') {
                        return {
                            status: 'fail',
                            message: 'Vui lòng chụp mặt sau của CCCD'
                        }
                    }
                    return {
                        status: 'pass',
                        message: 'Hình chụp CCCD hợp lệ'
                    }
                } else {
                    return {
                        status: 'fail',
                        message: 'Finsey chỉ chấp nhận CCCD'
                    }
                }
            } else {
                return {
                    status: "fail",
                    message: result.message
                }
            }
        } catch (error:any) {
            return {
                status: "error",
                message: error.response.data.vi_message,
            };
        }
    };

    ekycIdSpoofCheck = async (file: any) => {
        try {
            const result:any = await this.postEkyc("/id_spoof_check", { file });
            if (result.code == 1) {
                return {
                    status: "pass",
                    message: "Hình chụp CCCD đã hợp lệ",
                }
            } else {
                let message = result.message
                if (result.code == 265) {
                    message = 'Chụp từ thiết bị khác. Bạn có thể thử quay dọc thiết bị của bạn để chụp'
                }
                return {
                    status: "fail",
                    message
                }
            }
        } catch (error:any) {
            return {
                status: "error",
                message: error.response.data.vi_message,
            };
        }
    };

    ekycIdQualityCheck = async (file: any) => {
        try {
            const result:any = await this.postEkyc("/id_quality_check", { file });
            if (result.code == 1) {
                return {
                    status: "pass",
                    message: "Hình chụp CCCD đã hợp lệ",
                }
            } else {
                return {
                    status: "fail",
                    message: result.message
                }
            }
        } catch (error:any) {
            return {
                status: "error",
                message: error.response.data.vi_message,
            };
        }
    };

    ekycIdCard = async (fileIdFront: any, fileIdBack: any) => {
        try {
            const result:any = await this.postEkyc("/id_card", {
                image_back: fileIdFront,
                image_front: fileIdBack,
            });
            if (result.code == 1) {
                return {
                    status: 'pass',
                    message: 'Đã trích xuất thông tin thành công',
                    information: result.information
                }
            } else {
                return {
                    status: 'fail',
                    message: result.message,
                    information: null
                }
            }
            return result;
        } catch (error:any) {
            return {
                status: "error",
                message: error.response.data.vi_message,
                information: null
            };
        }
    };


    ekycFaceMatching = async (fileFace: any, fileId: any) => {
        try {
            const result:any = await this.postEkyc("/face_matching", {
                image_cmt: fileId,
                image_live: fileFace,
                ref_score: 0.9,
            });
            if (result.code == 1) {
                if (result.verify_result && result.score >= 0.9) {
                    return {
                        status: "pass",
                        message: "Hình chụp CCCD đã hợp lệ",
                    }
                } else {
                    return {
                        status: "fail",
                        message: "Hình chụp khuôn mặt và CCCD không khớp",
                    }
                }
            } else {
                return {
                    status: "fail",
                    message: result.message
                }
            }
        } catch (error:any) {
            return {
                status: "error",
                message: error.response.data.vi_message,
            };
        }
    };

    checkFace = async (file: any) => {
        try {
            const phase1 = await this.ekycFaceLiveness(file);
            if (phase1.status == "pass") {
                const phase2 = await this.ekycFaceQualityCheck(file);
                return phase2;
            } else {
                return phase1;
            }
        } catch (error) {
            throw error
        }

    };

    checkIdCard = async (file: any, type: string) => {
        try {
            const phase1 = await this.ekycIdQualityCheck(file)
            if (phase1.status == 'pass') {
                const phase2 = await this.ekycIdSpoofCheck(file)
                if (phase2.status == 'pass') {
                    const phase3 = await this.ekycIdTypeCheck(file, type)
                    return phase3
                } else {
                    return phase2
                }
            } else {
                return phase1
            }
        } catch (error) {
            throw error
        }

    };


    checkFaceMatching = async (face: any, idFront: any) => {
        try {
            const result = await this.ekycFaceMatching(face, idFront)
            return result
        } catch (error) {
            
        }
    }
}

export default ViettelEkycService;
